module.exports = __webpack_public_path__ + "static/img/picture.006da42.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/picture.jpg
// module id = 1774
// module chunks = 5